import { createAction, props } from '@ngrx/store';
import { IExplorerProjectsResponse } from '../../../interfaces/explorer/interfaces/IExplorerPaginatedProject';
import { IExplorerProject } from '../../../interfaces/explorer/interfaces/IExplorerProject';
import { IExplorerProjectAreaCreate } from '../../../interfaces/explorer/interfaces/IExplorerProjectArea';

// Richiesta dei progetti con paginazione
export const loadProjects = createAction(
  '[Project] Load Projects',
  props<{ page: number; size: number }>()
);

// Successo nel caricamento
export const loadProjectsSuccess = createAction(
  '[Project] Load Projects Success',
  props<{ data: IExplorerProjectsResponse }>()
);

// Errore nel caricamento
export const loadProjectsFailure = createAction(
  '[Project] Load Projects Failure',
  props<{ error: any }>()
);

export const createNewProject = createAction(
  '[Project] Create New Project',
  props<{ name: string; area: IExplorerProjectAreaCreate }>()
);

export const createNewProjectSuccess = createAction(
  '[Project] Create New Project Success',
  props<{ project: IExplorerProject }>()
);

export const createNewProjectFailure = createAction(
  '[Project] Create New Project Failure',
  props<{ error: any }>()
);
// Action per caricare TUTTI i progetti (senza paginazione)
export const loadAllProjects = createAction('[Project] Load All Projects');

export const loadAllProjectsSuccess = createAction(
  '[Project] Load All Projects Success',
  props<{ projects: IExplorerProject[] }>()
);

export const loadAllProjectsFailure = createAction(
  '[Project] Load All Projects Failure',
  props<{ error: any }>()
);

// Actions per il progetto corrente
export const setCurrentProject = createAction(
  '[Project] Set Current Project',
  props<{ project: IExplorerProject }>()
);

export const clearCurrentProject = createAction(
  '[Project] Clear Current Project'
);

export const searchProjects = createAction(
  '[Project] Search Projects',
  props<{
    page: number;
    size: number;
    name: string;
  }>()
);

export const searchProjectsSuccess = createAction(
  '[Project] Search Projects Success',
  props<{
    data: IExplorerProjectsResponse;
  }>()
);

export const searchProjectsFailure = createAction(
  '[Project] Search Projects Failure',
  props<{
    error: any;
  }>()
);
